import React, { useState } from 'react';

import { authEndpoints, endpoints } from '../../utils/Constants';
import { Button, Col, Row, FormGroup } from 'reactstrap';
import useFetch from '../../Services/useFetch';
import Modal from './Modal';
import FormContainer from './FormContainer';
import useFunction from '../../utils/Hooks/useFunction';
import { useEffect } from 'react';
import { ErrorMessage, getIn, useFormikContext } from 'formik';
import SelectSetting from '../Form/SelectSetting';
import TermsPanel from '../Pages/LoginPanels/TermsPanel';
import { FormLabel } from '../Form/FormLabel';
import { FormValue } from '../Form/FormLabel';
import DatePicker from '../Form/DatePicker'
import moment from 'moment';
import Selector from '../Form/Selector';

const BiddingEndDate = ({ id, label, parentItem}) => {

    const { setFieldValue, values } = useFormikContext();
    const svalue = getIn(values, id);
    const value = svalue?svalue:getIn(parentItem, id);
    const handleChange = (e) => {
        setFieldValue(id, e);
    }
    const lastDate = moment(getIn(parentItem, `routes[0].viewDepartDate`)).toDate();
    const minDate = moment().toDate();

    return  <Row style={{ height:320 }}>
        <Col>
            <FormGroup>
                <FormLabel>{label}</FormLabel>
                <DatePicker id={id} name={id} minDate={minDate} maxDate={lastDate} type='datetime-local' placeholder="Biddng Ends At" onChange={handleChange} selected={moment(value).toDate()} />
                <ErrorMessage name={id} />
            </FormGroup>
        </Col>        
    </Row>   
    
}
const CharterSelectState = ({ parentItem, id,label }) => {

    const [selection, setSelection] = useState();
    const [options, setOptions] = useState([]);
    const { setFieldValue, values } = useFormikContext();

    const [states, loading, error] = useFetch(authEndpoints.getLocationStates);
    const value = getIn(values, id)
    useEffect(() => {

        const options = states ? states.map((m) => { return { id: m.id, value: m.code, label: m.code + '-' + m.name,name:m.name }; }) : [];
        setOptions(options)
    }, [states]);
    useEffect(() => {
        if (options) {
            if (value) {

               
                const newOps = value.map(x => options.find(y => x === y.id));
                setSelection(newOps)

            }
            else {
                setSelection()
            }
        }
    }, [value, options]);
  
    const onSelectChange = val => {

        const value = val?.map((x) => x.id);
        setFieldValue(id, value);
    }
    
    useEffect(() => {
        if (parentItem) {
            let stas = {};
            parentItem.routes.map(x => {
                stas[x.fromState] = true;
                stas[x.toState] = true;
                if (x.fromAltState) stas[x.fromAltState] = true;
                if(x.toAltState) stas[x.toAltState] = true;
                return null;
            });
            const states = Object.keys(stas).map(x => x);
            const select = options.filter(x => {
                return states.filter(z => {
                    return z === x.value || z === x.name
                }).length > 0
            })
            setFieldValue(id, select.map((x) => x.id));
        }
    }, [parentItem,options,id,setFieldValue]);

    return <React.Fragment>
        <FormLabel htmlFor={id} style={{ display: 'block' }}>
            {label}
        </FormLabel>
        {error ? <h4>Error</h4> : null}
        {!loading ? <Selector onChange={onSelectChange} isMulti value={selection} options={options} /> : <FormValue><ul>{selection?.map((x, i) => <li key={i}>{x?.label}</li>)}</ul></FormValue>}
        <ErrorMessage name={id} />
    </React.Fragment>
}

const Reason = ({ source, id,label }) => {
    return  <Row style={{ height:380 }}>
    <Col>
    
    <SelectSetting endpoint={endpoints.getSettings + source} id={id} label={label} />
    </Col>
    </Row>
}

const ExtraDataModal = ({ extraData, parentEntityItem, onClose }) => {
    const [data, setData] = useState();
    const [handleSubmit, setHandleSubmit] = useFunction();
    const [isSubmitting, setSubmit] = useState();
     useEffect(() => {
        if (!data && extraData) {
            let v = {};
            extraData.map((x, i) => { v[x.dataSource] = ''; return x;})
            setData(v);
        }
    }, [extraData,data]);


    const NewActions = () => {
        const handleClick = () => {

            handleSubmit();
        }

        return isSubmitting ? null : <Button onClick={handleClick}>OK</Button>
    }
    const doSubmit = (values, actions) => {
        if (extraData[0].dataTypeRequired === 'BiddingEndDate') {
            const newVals = { ...values, biddingEndsAt: moment(values.biddingEndsAt).format('YYYY-MM-DDTHH:mm:ss') }
            onClose(newVals);
        }
        else if (extraData[0].dataTypeRequired === 'TermsAndConditions') {
            const newVals = { ...values, reason: 'Accepted Terms' }
            onClose(newVals);
        } else {
            onClose(values);
        }
       
      
    }
    const onCloseModal = () => {
        onClose(); 
    }
    const extraDataAll = extraData.map((item, i) => {

        if (item.dataTypeRequired === 'Reason') return <Reason key={i} id={'reason'} source={item.dataSource} label={item.dataTypeRequired} />;
        if (item.dataTypeRequired === 'TermsAndConditions') return <TermsPanel key={i} notUser type={item.dataSource} />;
        if (item.dataTypeRequired === 'CharterStateSelect') return <CharterSelectState key={i} parentItem={parentEntityItem} id='charterStates' label='State Filters' type={item.dataSource} />
        if (item.dataTypeRequired === 'BiddingEndDate') return <BiddingEndDate key={i} parentItem={parentEntityItem} id='biddingEndsAt' label='Bidding EndDate' type={item.dataSource} />
        return null;
    });
    const extraDataItems = extraDataAll.filter(x => x != null);



    return (<Modal open={extraDataItems && extraDataItems.length > 0} onClose={onCloseModal} title={"One More Thing..."} actions={<NewActions />}  >

        <FormContainer initialValues={{ data }}  edit={true} newRequest={true} setHandleSubmit={setHandleSubmit} onSubmit={doSubmit} setSubmitting={setSubmit}>
            {extraDataItems}
        </FormContainer >
    </Modal>

    )
}



export default ExtraDataModal; 